import React, { useContext, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useLocation } from 'react-router-dom'

import { AppContext } from '../contexts'
import { getPageMeta } from '../Helpers/pageMeta'

const removeServerCanonicalLinks = () => {
  if (typeof document === 'undefined') return

  // Canonical tags can be emitted by the server before the SPA takes over.
  // Remove them once so React Helmet owns canonical updates after hydration.
  const serverLinks = document.head.querySelectorAll('link[rel="canonical"]:not([data-react-helmet])')
  serverLinks.forEach(link => link.remove())
}

const MetaData = () => {
  const { appContext } = useContext(AppContext)
  const location = useLocation()
  const origin = typeof window !== 'undefined' ? window.location.origin : ''
  const pageMeta = getPageMeta(appContext, location.pathname, origin)
  const {
    title,
    description,
    keywords,
    robots,
    canonicalUrl,
    schemaList
  } = pageMeta

  useEffect(() => {
    removeServerCanonicalLinks()
  }, [])

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content={robots} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {schemaList.map((schemaItem, schemaIndex) => (
        <script key={`schema-${schemaIndex}`} type="application/ld+json">
          {JSON.stringify(schemaItem)}
        </script>
      ))}
    </Helmet>
  )
}

export default React.memo(MetaData)
